export var UserRole;
(function (UserRole) {
    UserRole["Patient"] = "patient";
    UserRole["Clinician"] = "clinician";
    UserRole["StudyAdmin"] = "study_admin";
    UserRole["WebAdmin"] = "web_admin";
})(UserRole || (UserRole = {}));
export class UserProfile {
    constructor(data) {
        this.id = data.id;
        this.roles = data.roles || [];
        this.first_name = data.first_name;
        this.last_name = data.last_name;
        this.date_of_birth = data.date_of_birth;
        this.timezone = data.timezone || 'America/New_York';
        this.is_hidden = data.is_hidden;
        this.email = data.email;
        this.photo_url = data.photo_url;
        this.created_at = data.created_at;
        this.updated_at = data.updated_at;
        this.email_confirmed_at = data.email_confirmed_at;
        this.last_sign_in_at = data.last_sign_in_at;
        this.assignments = data.assignments || [];
        this.studies = data.studies || [];
    }
}
export class UserProfileHelper {
    static isPatient(user) {
        return user?.profile?.roles.includes(UserRole.Patient) ?? false;
    }
    static isClinician(user) {
        return user?.profile?.roles.includes(UserRole.Clinician) ?? false;
    }
    static isStudyAdmin(user) {
        return user?.profile?.roles.includes(UserRole.StudyAdmin) ?? false;
    }
    static isWebAdmin(user) {
        return user?.profile?.roles.includes(UserRole.WebAdmin) ?? false;
    }
    static canAccessWebApp(user) {
        return this.isClinician(user) || this.isStudyAdmin(user) || this.isWebAdmin(user);
    }
    static canAccessMobileApp(user) {
        return this.isPatient(user);
    }
    static getDisplayName(user) {
        if (!user?.profile)
            return '';
        return `${user.profile.first_name} ${user.profile.last_name}`.trim();
    }
    static getPrimaryRole(user) {
        if (this.isWebAdmin(user))
            return UserRole.WebAdmin;
        if (this.isStudyAdmin(user))
            return UserRole.StudyAdmin;
        if (this.isClinician(user))
            return UserRole.Clinician;
        return UserRole.Patient;
    }
    /**
     * Returns an anonymized patient ID for display (e.g., "Patient #79CC")
     * Shows only the last 4 characters of the ID hash
     * @param id - The user ID (can be a string or extracted from a UserProfile)
     * @returns Formatted string like "Patient #79CC"
     */
    static getAnonymizedId(id) {
        const hash = id.substring(0, 8).toUpperCase();
        return `Patient #${hash.slice(-4)}`;
    }
    /**
     * Returns a hex color derived from a patient ID for visual identification
     * Uses the last 6 characters of the ID hash as a hex color
     * @param id - The user ID
     * @returns Hex color string like "#9679CC"
     */
    static getPatientColor(id) {
        const hash = id.substring(0, 8).toUpperCase();
        return `#${hash.slice(-6)}`;
    }
}
